/* tslint:disable */

import { CMSResource } from "app/resources/cmsresource";
import { AppointmentStatusResource } from "./AppointmentStatusResource";




export class AppointmentFilter extends CMSResource {

	id: number;

	appointmentStatus: AppointmentStatusResource;

	departmentId: number;

	assignedUserEmail: string;

	firstName: string;

	lastName: string;

	phone: string;

	email: string;

	createdDate: Date;

	pageNumber: number;
	
	itemPerPage: number;

}
